import { ErrorMessage, Field } from "formik";
import React from "react";
import Mandatory from "../../shared/Mandatory";

const FormField = ({
  name,
  type,
  htmlFor,
  placeholder,
  label,
  nonMandatory,
}) => {
  const additonalProp = {};
  if (type === "textarea") additonalProp["as"] = type;
  return (
    <div className="relative mb-4">
      <label htmlFor={htmlFor} className="flex items-center pb-3">
        <Mandatory label={label} nonMandatory={nonMandatory} />
      </label>
      <Field
        className="block w-full rounded-md p-2 text-sm bg-gray-100 border-2 border-gray-200 outline-none focus:border-indigo-400"
        type={type}
        name={name}
        placeholder={placeholder}
        {...additonalProp}
      />
      <ErrorMessage
        className="text-xs text-red-500"
        name={name}
        component="span"
      />
    </div>
  );
};

export default FormField;
